import InputNumberBuilder from "./InputNumberBuilder";

export default InputNumberBuilder;
